import { render, staticRenderFns } from "./SignUpSetting.vue?vue&type=template&id=df242018&"
import script from "./SignUpSetting.vue?vue&type=script&lang=js&"
export * from "./SignUpSetting.vue?vue&type=script&lang=js&"
import style0 from "./SignUpSetting.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports